import React from "react";
import { useRoutes } from "react-router-dom";
import Home from "pages/Home";
import NotFound from "pages/NotFound";
import Home1 from "pages/Home1";
import Solutions from "pages/Solutions";
import Aboutus from "pages/Aboutus";
import Blogs from "pages/Blogs";
import CaseStudies from "pages/CaseStudies";
import Career from "pages/Career";
import ContactUs from "pages/ContactUs";
import Bookademo from "pages/Bookademo";
import BlogsInternal from "pages/BlogsInternal";
import BlogsInternalPage from "pages/BlogsInternal";
import BlogPostSection from "pages/BlogsInternal/BlogPostSection";
import PrivacyPolicy from "pages/PrivacyPolicy";
import BlogPost from "pages/BlogsInternal/BlogsMarkDown";

const ProjectRoutes = () => {
  let element = useRoutes([
    { path: "/", element: <Home1 /> },
    { path: "*", element: <NotFound /> },
    {
      path: "all",
      element: <Home />,
    },
    {
      path: "solutions",
      element: <Solutions />,
    },
    {
      path: "aboutus",
      element: <Aboutus />,
    },
    {
      path: "blogs",
      element: <Blogs />,
    },
    {
      path: "blog/:id",
      element: <BlogPost />,
    },
    // {
    //   path: "casestudies",
    //   element: <CaseStudies />,
    // },
    {
      path: "career",
      element: <Career />,
    },
    {
      path: "contactus",
      element: <ContactUs />,
    },
    {
      path: "bookademo",
      element: <Bookademo />,
    },
    {
      path: "privacypolicy",
      element: <PrivacyPolicy />
    },
    // {
    //   path: "blogmd",
    //   element: <BlogPost />
    // }
    // {
    //   path: "blogsinternal",
    //   element: <BlogsInternal />,
    // },
  ]);

  return element;
};

export default ProjectRoutes;
